import React, { Component } from 'react'
import { Switch, Route, Link } from 'react-router-dom'

import { MenuIcon, PlusIcon } from '../SVGIcons'
import LBUSearchBox from '../LBUSearchBox/LBUSearchBox'

import './Header.css'

class Header extends Component {

    render() {

        return (
	        <header className="Header">
	            <div
	                className="menuButton"
	                onClick={this.props.onShowMenu}>
	                <MenuIcon />
	            </div>
							<Switch>
								<Route path="/" exact render={(props) => (
									<div className="content home">
										<div className="appName">Shmadmin</div>
										<h1>Shmadmin</h1>
									</div>
								)}/>
								<Route path="/lbus" render={(props) => (
									<div className="content lbus">
										<div className="appName">Shmadmin</div>
										<h1>LBUs</h1>
										<LBUSearchBox {...props} />
                    <Link className="action" to="/lbus/add"><PlusIcon /><span>Add</span></Link>
									</div>
								)}/>
								<Route path="/categories" exact render={(props) => (
									<div className="content categories">
										<div className="appName">Shmadmin</div>
										<h1>Categories</h1>
										<Link className="action" to="/categories/add"><PlusIcon /> Add</Link>
									</div>
								)}/>
								<Route path="/synonyms" exact render={(props) => (
									<div className="content synonyms">
										<div className="appName">Shmadmin</div>
										<h1>Synonyms</h1>
									</div>
								)}/>
								<Route path="/blockwords" exact render={(props) => (
									<div className="content blockwords">
										<div className="appName">Shmadmin</div>
										<h1>Block words</h1>
									</div>
								)}/>
							</Switch>
	        </header>
	      )
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js